/**
 * @generated SignedSource<<8c81583bc0ebe84fc0f1017d583765fb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EducationLevelsMultiSelectInput_query$data = {
  readonly educationLevels: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "EducationLevelsMultiSelectInput_query";
};
export type EducationLevelsMultiSelectInput_query$key = {
  readonly " $data"?: EducationLevelsMultiSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EducationLevelsMultiSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EducationLevelsMultiSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "EducationLevelConnection",
      "kind": "LinkedField",
      "name": "educationLevels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EducationLevel",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "educationLevels(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "dde47a5bd0bbe4cc2c6b89d5ec0354ea";

export default node;
